import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	flagTitle: {
		id: 'issue-navigator-actions-common.error-flag.flag-title',
		defaultMessage: "Filter couldn't be saved",
		description: 'Title for the flag shown when filter could not be saved',
	},
});
